import { render, staticRenderFns } from "./AuthIcon.vue?vue&type=template&id=7ed6f2c0&scoped=true&"
import script from "./AuthIcon.vue?vue&type=script&lang=js&"
export * from "./AuthIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed6f2c0",
  null
  
)

export default component.exports